export default __webpack_public_path__ + "assets/f1c835af98785ccafb2ef06be433e3fa.png";